<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "UnsubscribedModal" });
import { Modal } from "../../../../components/index.js";
import { Paragraph, Heading } from "../../../../typography/index.js";
let isSimilarMatch = false;
if (typeof window !== "undefined") {
    const PARAMS = new URLSearchParams(window.location.search);
    isSimilarMatch = PARAMS.get("isSimilarMatch") === "1";
}
</script>

<Modal hash = '#unsubscribed' >
    <Heading size = 'sm'>Successfully Unsubscribed!</Heading>
    {#if isSimilarMatch}
        <Paragraph>
            You will no longer receive email notifications for auctions related
            to similar brands on this saved search.
        </Paragraph>
        <Paragraph>
            If you're still interested in receiving notifications for similar brand matches,
            You can reactivate the option "Recommend Similar Brands" in your subscription preferences.
        </Paragraph>
    {:else}
        <!-- DEFAULT TEXT -->
        <Paragraph>
            Your notifications for saved searches have been paused,
            so you won't receive any more updates for matching auctions.
        </Paragraph>
        <Paragraph>
            If you're still interested in receiving notifications for similar
        </Paragraph>
        {/if}
        <Paragraph>
            If there's anything we can do better, please let us know!
        </Paragraph>
</Modal>